"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalErrorDisplay = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const HackerButton_1 = require("./HackerButton");
const ModalErrorDisplay = ({ error, onClose, }) => {
    const { colors: { hackerRed }, } = (0, react_1.useTheme)();
    if (!error) {
        return react_2.default.createElement(react_2.default.Fragment, null);
    }
    return (react_2.default.createElement(react_1.Flex, { direction: "column", h: "full", w: "full", justifyContent: "center", alignItems: "center" },
        react_2.default.createElement(react_1.Box, { color: "hackerRed", fontSize: 20, mb: 5 }, error),
        react_2.default.createElement(react_1.Box, { hidden: !onClose },
            react_2.default.createElement(HackerButton_1.HackerButton, { size: "sm", colorHex: hackerRed, onClick: onClose }, "Close"))));
};
exports.ModalErrorDisplay = ModalErrorDisplay;
//# sourceMappingURL=ModalErrorDisplay.js.map